export const LB_USER_ID_HEADER = 'x-lb-user-id'
export const COUNTRY_HEADER = 'cloudfront-viewer-country'
